import {
  Badge,
  Box,
  Button,
  Divider,
  Group,
  LoadingOverlay,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';

import { useConfigCurrencies } from '../hooks/use-config-currencies';

export const Currencies = () => {
  const {
    currencies,
    form,
    isLoading,
    handleSubmit,
  } = useConfigCurrencies();
  const codeInputProps = form.getInputProps('code');

  return (
    <Box pos="relative">
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />

      <Stack gap="xl">
        <Box maw={480}>
          <Title order={5} mb="md">Добавить валюту</Title>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput
              label="Код валюты"
              description="От 3 до 12 заглавных латинских букв"
              placeholder="Например, AED"
              withAsterisk
              {...codeInputProps}
              onChange={(event) => form.setFieldValue('code', event.currentTarget.value.toUpperCase())}
            />
            <Group justify="flex-start" mt="md">
              <Button type="submit" loading={isLoading}>
                Добавить
              </Button>
            </Group>
          </form>
        </Box>

        <Divider />

        <Box>
          <Title order={5} mb="md">Доступные валюты</Title>
          {currencies.length > 0
            ? (
              <Group gap="xs">
                {currencies.map((currency) => (
                  <Badge key={currency} size="lg" variant="light">
                    {currency}
                  </Badge>
                ))}
              </Group>
            )
            : <Text c="dimmed">Валюты не найдены</Text>}
        </Box>
      </Stack>
    </Box>
  );
};
